export default __webpack_public_path__ + "static/media/ArrowLeft.73b351df.svg";